import {
	Component,
	EventEmitter,
	Input,
	Output,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { ApiService } from "@app/services/api.service"
import { PermsService } from "@app/services/perms.service"
import { StoreService } from "@app/services/store.service"
import { UpdateFieldComponent } from "@app/update-field/update-field.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"

@Component({
	selector: "app-require-cc-field",
	imports: [
		COMMON_IMPORTS,
		ModalWrapComponent,
		UpdateFieldComponent,
		LangValPipe,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		@if (isOpen) {
			<app-modal-wrap
				(onClose)="isOpen = false; handleClose()"
				modalWrapperClass="modal-wide"
				[title]="('update' | langVal) + ' - ' + (fieldName | langVal)"
			>
				<app-update-field
					(onClose)="isOpen = false; handleClose($event)"
					[fieldName]="fieldName"
				/>
			</app-modal-wrap>
		}
	`,
})
export class RequireCcFieldComponent {
	@Output() onDone = new EventEmitter()
	@Input() fieldName: string = ""
	@Input() apiCall: string = ""
	isOpen: boolean = false

	constructor(
		public apiService: ApiService,
		public store: StoreService,
		public permsService: PermsService
	) {}

	handleClose(ret: any = null) {
		if (!ret) {
			this.onDone.emit(false)
			return
		}
		const cc = this.store.cc()
		cc[this.fieldName] = ret
		sessionStorage.setItem("cliniqData", JSON.stringify(cc))
		this.apiService.post(this.apiCall, {
			[this.fieldName]: ret,
		})
		this.onDone.emit(true)
	}
	ngOnInit() {
		setTimeout(() => this.init())
	}
	init() {
		if (!this.permsService.owner_has_users) {
			this.onDone.emit(true)
			return
		}
		const cc = this.store.cc()

		if (cc[this.fieldName]) {
			this.onDone.emit(true)
			return
		}
		this.isOpen = true
	}
}

@Component({
	selector: "app-require-default-signature",
	imports: [RequireCcFieldComponent],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<app-require-cc-field
			fieldName="default_signature"
			apiCall="update_default_signature"
			(onDone)="onDone.emit($event)"
		/>
	`,
})
export class RequireDefaultSignatureComponent {
	@Output() onDone = new EventEmitter()
}
